/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-display-third-party-cso',
  templateUrl: './display-third-party-cso.component.html',
  styleUrls: ['./display-third-party-cso.component.scss']
})
export class DisplayThirdPartyCsoComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

}
